module.exports = __webpack_public_path__ + "static/media/tarjeta_visa.93023b58.svg";